import { rest } from 'msw';

import { API_URLS } from '~/configs/api/urls';
import { US_STOCK_TRADE_FEE } from '~/constants/FEE';
import { FooterDescriptions } from '~/constants/FOOTER_DESCRIPTIONS';

const MOCK_FOOTER_RESPONSE: FooterDescriptions = [
  {
    title: '투자자 유의사항',
    noticeList: [
      '투자자는 금융투자상품에 대하여 카카오페이증권으로부터 충분한 설명을 받을 권리가 있으며, 투자전 상품설명서 등을 반드시 읽어보시기 바랍니다.',
      '금융투자상품은 예금자보호법에 따라 예금보험공사가 보호하지 않습니다.',
      '금융투자상품은 자산가격 변동, 환율 변동 등에 따라 투자원금손실(0~100%)이 발생할 수 있으며, 그 손실은 투자자에게 귀속됩니다.',
      `주식거래 시 수수료는 국내 KRX 0.015%, NXT 0.014%(유관기관 제비용 포함), 미국 ${US_STOCK_TRADE_FEE}%이며, 기타 자세한 사항은 홈페이지 등을 참고하시기 바랍니다.`,
      '미국주식 매도시 0.0008% SEC FEE 등 제비용 별도 부과됩니다.',
    ],
  },
];

const getContentsFooterMock = rest.get(
  `${API_URLS.FOOTER}/:footerType`,
  async (_, res, ctx) => res(ctx.json(MOCK_FOOTER_RESPONSE))
);

export default getContentsFooterMock;
